import ClientStatementSlice from "./clientStatement";
import RecordPayment from "./clientStatement/recordPayment";
import ApprovePaymentSlice from "./clientStatement/approvePayment";
import invoiceSlice from "./invoice";
import BankDetailsSlice from "./bank-details";
import BankApproveSlice from "./bank-approve";
import KYCStatusActivitySlice from "./kycStatus";
import OutstandingBalance from "./clientStatement/outstandingBalance";
import CreditNoteSlice from "./creditNotes";
import reportSlice from "./reports";
import EmailListSlice from "./emailList";
import InvoiceItemMasterSlice from "./invoiceItemMaster";
import RentalBillsSlice from "./rental-bills";
import SupplementaryBillsSlice from "./supplementary-bills";
import reducersReports from "./reports";
import MemberSubscriptionInvoiceSlice from "./invoice/memberSubscriptionInvoiceList";
import GenerateRentalInvoiceSlice from "./generateRentalInvoice";

const reducersacclgl = {
  clientStatement: ClientStatementSlice,
  recordPayment: RecordPayment,
  approvePayment: ApprovePaymentSlice,
  invoice: invoiceSlice,
  bankdetails: BankDetailsSlice,
  bankapprove: BankApproveSlice,
  kycStatus: KYCStatusActivitySlice,
  outstandingbalance: OutstandingBalance,
  creditNote: CreditNoteSlice,
  report: reportSlice,
  emaillist: EmailListSlice,
  invoiceItemMaster: InvoiceItemMasterSlice,
  rentalBills: RentalBillsSlice,
  supplementarybills: SupplementaryBillsSlice,
  memberSubscriptionInvoice: MemberSubscriptionInvoiceSlice,
  generateRentalInvoice: GenerateRentalInvoiceSlice,
  ...reducersReports,
};
export default reducersacclgl;
